module.exports = __webpack_public_path__ + "static/media/cannot-access-dialog.3ddd1b4a.png";